import { isMriGoPath } from "@/lib/booking"
import { isImagingProductSlug } from "@/data/tests"
import { canonicalSlugPath } from "@/lib/localized-route-slugs"

/**
 * Pages whose navbar + footer booking CTAs open the booking app's MRI tab
 * (AHD-7129): the MRI `/go` landing pages, the Zurich full-body MRI page,
 * `/pricing` (MRI is the default check-up there), and every imaging test page,
 * i.e. `/tests/<slug>` for the full-body MRI or one of its imaging add-ons, the
 * same `isImagingProductSlug` split the test page's own CTAs use.
 *
 * Test slugs are localized (FR `/tests/irm-prostate`), so the path is
 * canonicalised first; that also keeps the server (rewritten, canonical) and
 * client (public, localized) pathnames agreeing. Lives outside `lib/booking`
 * because `data/tests` imports that module.
 */
export function isMriBookingPath(pathname: string): boolean {
  if (isMriGoPath(pathname)) return true
  const bare = `/${pathname.split("/").filter(Boolean).slice(2).join("/")}`
  if (bare === "/full-body-mri-zurich" || bare === "/pricing") return true
  const [section, slug, ...rest] = canonicalSlugPath(bare)
    .split("/")
    .filter(Boolean)
  return (
    section === "tests" &&
    slug !== undefined &&
    rest.length === 0 &&
    isImagingProductSlug(slug)
  )
}
